import './item.less';

import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';
import onClickOutside from 'react-onclickoutside';

import Result from './result';

const propTypes = {
	placeholder: PropTypes.string,
	name: PropTypes.string,
	isOpen: PropTypes.bool,
	isSubPermission: PropTypes.bool,
	options: PropTypes.array,
	intl: PropTypes.func,
	onToggle: PropTypes.func,
	onToggleSelect: PropTypes.func
};

const Item = ({
	placeholder,
	name,
	isOpen,
	isSubPermission,
	options,
	intl,
	onToggle,
	onToggleSelect
}) => {
	const result = getResult(options);
	const disabled = shouldDisable(options);
	return (
		<div className="permission-control__select-wrap">
			<div className={cn(
				'permission-control__select',
				isOpen && 'is--opened',
				isSubPermission && 'is--subpermission',
				disabled && 'is--disabled'
			)}>
				{ isSubPermission && <span className="subpermission-sign" /> }
				<div className="permission-control__select-head" onClick={ () => !disabled && onToggle(name) }>
					<span className="title">{placeholder}</span>
				</div>

				{ isOpen && (
					<div className="permission-control__select-suggest">
						{ options.filter(option => !option.isSelected).map(option => (
							<div
								key={option.value}
								className={cn('item show', option.isSelected && 'is--selected')}
								onClick={ () => onToggleSelect(name, option.value) }>
								<span className={cn('item-title', option.icon)}>{intl(option.label)}</span>
							</div>
						))}
					</div>
				) }
			</div>
			<Result
				options={result}
				controlName={name}
				onDelete={onToggleSelect}
				intl={intl}
				isSubPermission={isSubPermission} />
		</div>
	);
};

Item.propTypes = propTypes;
export default onClickOutside(Item, {
	handleClickOutside: instance => () => {
		const { name, isOpen, onToggle } = instance.props;

		if (isOpen) {
			onToggle(name);
		}
	}
});

// functions
const getResult = options => options.filter(option => option.isSelected);
const shouldDisable = options => !options.filter(option => !option.isSelected).length;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/admins/components/permissions/control/item.js